import { IntlShape } from 'react-intl';

export const formatDate = (rawDate: string, intl: IntlShape) => {
  if (!rawDate) {
    return '';
  }
  const date = new Date(rawDate);
  if (isNaN(date.getTime())) {
    return rawDate;
  }
  const formattedDate = intl.formatDate(date, { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });
  const formattedTime = intl.formatTime(date);
  return `${formattedDate} ${formattedTime}`;
};
